import React from 'react';
import ButtonGroup from 'ub/components/properties-panel/button-group';
import IconJustify from 'icons/inline-text/justify-icon';

const TextAlignmentButtonGroup = ({alignment, changeHandler}) => {
  const _triggerChangeForStyle = (newAlignment) => {
    changeHandler({
      type: 'alignmentChange',
      value: newAlignment
    });
  };

  const alignmentOptions = [
    {
      iconClass: "svg-ico-align-left medium",
      clickHandler: () => _triggerChangeForStyle('left'),
      isActive: alignment && alignment === 'left',
      title: 'Left Align'
    },
    {
      iconClass: "svg-ico-align-center medium",
      clickHandler: () => _triggerChangeForStyle('center'),
      isActive: alignment && alignment === 'center',
      title: 'Center Align'
    },
    {
      iconClass: "svg-ico-align-justify medium",
      icon: IconJustify,
      clickHandler: () => _triggerChangeForStyle('justify'),
      isActive: alignment && alignment === 'justify',
      title: 'Justify Align'
    },
    {
      iconClass: "svg-ico-align-right medium",
      clickHandler: () => _triggerChangeForStyle('right'),
      isActive: alignment && alignment === 'right',
      title: 'Right Align'
    }
  ];
  return (<ButtonGroup options={alignmentOptions} />);
};

TextAlignmentButtonGroup.propTypes = {
  alignment: React.PropTypes.string,
  changeHandler: React.PropTypes.func
};

export default TextAlignmentButtonGroup;



// WEBPACK FOOTER //
// ./src/ui/inline-text/style-tab-content-components/text-alignment-button-group.jsx